module.exports = __webpack_public_path__ + "img/plus.f57f6993.png";